import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Alert, Backdrop, Box, CircularProgress, Container, Snackbar } from "@mui/material";
import { Padding, PaletaColor } from "../../../../styles/StylesConstantes";
import { getFiltrarFacturas, getFiltrarObsequios, getFiltrarUsuarios, getLocalesFiltrarPorNombre, getObsequiosListar, getReporteObsequios } from "../../../../api/ApiService";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Delete, Edit } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FacturasTableComponent from "./components/FacturasTableComponent";
import FitrosFacturasComponent from "./components/FitrosFacturasComponent";
import ModalExcel from "./components/ModalExcel";

const optionsProcesados = [
    { label: 'Todos', value: "todos", id: 1 },
    { label: 'Sistema', value: "sistema", id: 2 },
    { label: 'Usuarios del sistema', value: "usuario_sistema", id: 3 },
    //   { label: 'Atención al cliente', value: "atencion_al_cliente", id: 4 }, ,
];

const optionsEstado = [
    { label: 'Activo', value: "activo", id: 1 },
    { label: 'Eliminados', value: "eliminados", id: 2 },
    { label: 'Todos', value: "todos", id: 3 },
];

function ListarFacturasObsequiosPage() {
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataFacturas, setDataFacturas] = useState([]);


    const [nroFactura, setNroFactura] = useState('');
    const [montoDesde, setMontoDesde] = useState('');
    const [montoHasta, setMontoHasta] = useState('');

    const [locales, setLocales] = useState([]);
    const [localesSearch, setLocalesSearch] = useState('');
    const [localesSelected, setLocalesSelected] = useState(null);
    const [loadingCargarLocales, setLoadingCargarLocales] = useState(false);

    const [estadosSelected, setEstadosSelected] = useState(null);

    const [dataObsequios, setDataObsequios] = useState([]);
    const [obsequiosSearch, setObsequiosSearch] = useState('');
    const [obsequioSelected, setObsequioSelected] = useState(null);
    const [loadingCargarObsequio, setLoadingCargarObsequio] = useState(false);

    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [usuarioNameSearch, setUsuarioNameSearch] = useState('');
    const [nameSelected, setNameSelected] = useState(null);
    const [loadingCargarName, setLoadingCargarName] = useState(false);

    const [procesadoPorSelected, setProcesadoPorSelected] = useState(null);

    const [openModal, setOpenModal] = useState(false);
    const [idObsequioDocumento, setIdObsequioDocumento] = useState(null);
    const [loadingCargarExcel, setLoadingCargarExcel] = useState(false);
    const [dataExcel, setDataExcel] = useState(null);


    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');


    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaInicioBackend, setFechaInicioBackend] = useState('');
    const [fechaFin, setFechaFin] = useState(null);
    const [fechaFinBackend, setFechaFinBackend] = useState('');


    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);



    const stateToken = useSelector(state => state.reducerGlobal.token);

    let history = useNavigate();



    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (fechaInicio || fechaFin || obsequioSelected || localesSelected || estadosSelected || procesadoPorSelected || nameSelected || nroFactura || montoDesde || montoHasta) {

                handleApiFiltrarInicialObsequios();
            } else {
                handleApiFiltrarObsequios(1);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, perPage, fechaInicioBackend, fechaFinBackend, obsequioSelected, localesSelected, estadosSelected, procesadoPorSelected, nameSelected, nroFactura, montoDesde, montoHasta]);








    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (localesSearch.length > 2) {
                setLoadingCargarLocales(true);
                handleListarLocales(localesSearch);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, localesSearch]);


    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (obsequiosSearch.length > 2) {
                handleApiFiltrarObsequiosNombre();
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, obsequiosSearch]);





    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarObsequiosNombre = () => {

        let body = {
            page: '1',
            per_page: "10",
            titulo: obsequiosSearch

        };
        // console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargarObsequio(true);

        getFiltrarObsequios(stateToken?.access_token, body)
            .then(response => {
                console.log("response==>getFiltrarObsequios", response);

                setLoadingCargarObsequio(false);
                // setMetaPaginacion(response.meta);

                if (response?.data?.data?.length > 0) {
                    setDataObsequios(response.data.data);
                } else {
                    setDataObsequios([]);
                }




            })
            .catch(error => {
                console.log("error==>getFiltrarObsequios", error);
                setDataObsequios([]);
                setLoadingCargarObsequio(false);
            })
    };





    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarInicialObsequios = () => {

        let body = {
            page: 1,
            per_page: perPage,
            fecha_desde: fechaInicioBackend === "" ? "" : fechaInicioBackend,
            fecha_hasta: fechaFinBackend === "" ? "" : fechaFinBackend,
            obsequio_id: obsequioSelected?.id === undefined ? "" : obsequioSelected?.id,
            nro_factura: nroFactura,
            local_id: localesSelected?.id === undefined ? "" : localesSelected?.id,
        };
        // console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        getObsequiosListar(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getObsequiosListar", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response?.data?.data?.length > 0) {
                    setDataFacturas(response.data.data);
                    setLoading(true);
                } else {
                    setDataFacturas([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.data?.current_page,
                    per_page: response?.data?.per_page,
                    total: response?.data?.total,
                    last_page: response?.data?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getObsequiosListar", error);
                setDataFacturas([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };




    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarObsequios = (page = 1) => {

        let body = {
            page: page,
            per_page: perPage,
            fecha_desde: fechaInicioBackend === "" ? "" : fechaInicioBackend,
            fecha_hasta: fechaFinBackend === "" ? "" : fechaFinBackend,
            obsequio_id: obsequioSelected?.id === undefined ? "" : obsequioSelected?.id,
            nro_factura: nroFactura,
            local_id: localesSelected?.id === undefined ? "" : localesSelected?.id,

        };
        // console.log("body-handleApiFiltrarObsequios", body);


        setLoadingCargar(true);

        getObsequiosListar(stateToken?.access_token, body)
            .then(response => {
                console.log("response==>getObsequiosListar", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response?.data?.data?.length > 0) {
                    setDataFacturas(response.data.data);
                    setLoading(true);
                } else {
                    setDataFacturas([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.data?.current_page,
                    per_page: response?.data?.per_page,
                    total: response?.data?.total,
                    last_page: response?.data?.last_page
                });


            })
            .catch(error => {
                console.log("error-getObsequiosListar==>", error);
                setDataFacturas([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };








    //=================================================================================================funcion para listar las categorias
    const handleListarLocales = (busqueda) => {

        getLocalesFiltrarPorNombre(busqueda, stateToken?.access_token)
            .then((response) => {
                console.log("response-getLocalesFiltrarPorNombre", response?.data);
                setLoadingCargarLocales(false);
                if (response.data.length > 0) {
                    setLocales(response.data);
                } else {
                    setLocales([]);
                }
            })
            .catch((error) => {
                console.log("error-getLocalesFiltrarPorNombre", error);
                setLoadingCargarLocales(false);
                setLocales([]);
            });
    };




















































    //=============================================funcion para capturar el nro de factura
    const handleNroFactura = (e) => {
        setNroFactura(e);
    }

    //=============================================funcion para capturar el monto desde
    const handleMontoDesde = (e) => {
        setMontoDesde(e);
    }

    //=============================================funcion para capturar el monto hasta
    const handleMontoHasta = (e) => {
        setMontoHasta(e);
    }









    //=============================================funcion para eliminar
    const handleDeleteClick = (id) => () => {
        console.log('Delete', id);
        setDataFacturas(dataFacturas.filter((row) => row.id !== id));
    }




    //=============================================funcion para seleccionar la fecha inicio
    const handleFechaInicio = (event) => {
        // console.log("event", event);
        setFechaInicio(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaInicioBackend(fecha);


    };








    //=============================================funcion para seleccionar la fecha fin
    const handleFechaFin = (event) => {
        // console.log("event", event);
        setFechaFin(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        // console.log("fecha", fecha);
        setFechaFinBackend(fecha);

    };










    //=============================================funcion para buscar el nombre del cliente
    const handleNameObsequioSearch = (e) => {
        setObsequiosSearch(e);
    };

    //=========================================================funcion para seleccionar el nombre del cliente
    const handleObsequioSelected = (value) => {
        // console.log("value-handleObsequioSelected##########>>> ", value);
        setObsequioSelected(value);

    };









    //=============================================funcion para buscar el nombre del usuario
    const handleUsuarioNameSearch = (e) => {
        // console.log("event-handleNameSearch------>", e);
        setUsuarioNameSearch(e);
    };

    //=========================================================funcion para seleccionar el nombre del usuario
    const handleNameSelected = (value) => {
        // console.log("value-handleNameSelected##########>>> ", value);
        setNameSelected(value);

    };







    //=========================================================funcion para seleccionar el procesado por
    const handleProcesadoSelected = (value) => {
        console.log("value-handleProcesadoSelected: ", value);
        setProcesadoPorSelected(value);

    };









    //=========================================================funcion para seleccionar el estado
    const handleEstadoSelected = (value) => {
        console.log("value-handleEstadoSelected: ", value);
        setEstadosSelected(value);
    };







    //=========================================================funcion para seleccionar local
    const handleLocalSelected = (value) => {
        console.log("value-handleCategoriaSelected: ", value);
        setLocalesSelected(value);
    };

    //=========================================================funcion para buscar local
    const handleSearchLocal = (value) => {
        console.log("value-handleSearchCategoria: ", value);
        setLocalesSearch(value);
    };



    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
















    //=============================================funcion para editar
    const handleEditClick = (item) => {
        // console.log('Edit', id, row);
        history('/app/admin/obsequios/factura-detalle/' + item?.id, {
            state: { data: item }
        });
    };

    //=============================================funcion para ver
    const handleVerObsequio = (item) => {
        // console.log('View', id, row);
        history('/app/admin/obsequios/factura-detalle/' + item?.id + '?mode=view');
    };




    const handleOpenModalExcel = (id) => {
        setIdObsequioDocumento(id);
        setOpenModal(true);
    };



    //=================================================================================================funcion para listar las categorias
    const handleDescargarExcel = () => {
        setLoadingCargarExcel(true);


        getReporteObsequios(stateToken?.access_token, idObsequioDocumento)
            .then((response) => {
                // console.log("response-getReporteObsequios", response);
                setLoadingCargarExcel(false);
                setDataExcel(response?.url);

            })
            .catch((error) => {
                console.log("error-getReporteObsequios", error);
                setLoadingCargarExcel(false);

                setOpen(true);
                setSeverity("error");
                setMensaje("Error al generar el reporte de obsequios");
            });
    };


    //========================================================= funcion para cerrar la alerta
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div>
                        <FitrosFacturasComponent
                            title={'Facturas de obsequios'}

                            nroFactura={nroFactura}
                            handleNroFactura={handleNroFactura}

                            montoDesde={montoDesde}
                            handleMontoDesde={handleMontoDesde}

                            montoHasta={montoHasta}
                            handleMontoHasta={handleMontoHasta}


                            estadosSelected={estadosSelected}
                            handleEstadoSelected={handleEstadoSelected}



                            dataLocales={locales}
                            loadingCargarLocales={loadingCargarLocales}
                            localesSelected={localesSelected}
                            handleLocalSelected={handleLocalSelected}
                            handleSearchLocal={handleSearchLocal}



                            procesadoPorSelected={procesadoPorSelected}
                            handleProcesadoSelected={handleProcesadoSelected}


                            fechaInicio={fechaInicio}
                            handleFechaInicio={handleFechaInicio}

                            fechaFin={fechaFin}
                            handleFechaFin={handleFechaFin}

                            obsequioSelected={obsequioSelected}
                            loadingCargarObsequio={loadingCargarObsequio}
                            dataObsequios={dataObsequios}
                            handleNameObsequioSearch={handleNameObsequioSearch}
                            handleObsequioSelected={handleObsequioSelected}

                            nameSelected={nameSelected}
                            dataUsuarios={dataUsuarios}
                            loadingCargarName={loadingCargarName}
                            handleUsuarioNameSearch={handleUsuarioNameSearch}
                            handleNameSelected={handleNameSelected}

                            optionsProcesados={optionsProcesados}
                            optionsEstado={optionsEstado}

                        />

                        <div>
                            <FacturasTableComponent
                                data={dataFacturas}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarObsequios}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                // handleEditarItem={handleEditClick}

                                handleEditarItem={handleEditClick}
                                handleVerObsequio={handleVerObsequio}
                                handleOpenModalExcel={handleOpenModalExcel}
                            />
                        </div>


                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}

                <ModalExcel
                    openModal={openModal}
                    loading={loadingCargarExcel}
                    handleCloseModal={() => {
                        setOpenModal(false);
                        setDataExcel(null);
                    }}
                    handleDescargarExcel={handleDescargarExcel}
                    dataExcel={dataExcel}
                />

                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>


                <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                        {mensaje}
                    </Alert>
                </Snackbar>
            </div>
        </HeaderCustom>
    );
}

export default ListarFacturasObsequiosPage;